import axios from '../utils/axios';

export function tencentLiveCode(data) {
  return axios('/ttd-tool-service/tencent/liveCode', data);
}

export function tencentLivenessRecognition(data) {
  return axios('/ttd-tool-service/tencent/livenessRecognition', data);
}
